import React, { useState } from 'react'
import { NotificationType } from './NotificationType.type'
import './style.module.scss'
import { sanitizeHTML } from '../../../utils/common-utils'

export type NotificationProps = {
  children?: React.ReactNode
  message?: string
  analytics?: string
  type: NotificationType
  dismissable: boolean
  handleCloseNotification?: (closed: boolean) => void
  testId?: string
}

export const Notification = (props: NotificationProps) => {
  const { children, message, analytics, type, dismissable, handleCloseNotification, testId } = props
  const notificationClass =
    'Notification ' +
    (dismissable ? 'Notification--dismissable ' : '') +
    'Notification--withIcon Notification--' +
    type
  const ariaRole = type == 'alert' ? 'alert' : 'status'
  const [hideNotification, setHideNotification] = useState(false)

  const closeNotification = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    setHideNotification(true)
    if (handleCloseNotification) {
      handleCloseNotification(true)
    }
  }

  if (hideNotification) {
    return null
  }

  return (
    <section className='u-sizeConstrained u-marginTop20' data-testid={testId ? `${testId}` : null}>
      <div
        className={notificationClass}
        role={ariaRole}
        data-testid={testId ? `${testId}-type` : null}>
        <div className='Notification-content'>
          <div
            className={dismissable ? 'u-marginRight8' : ''}
            data-testid={testId ? `${testId}-message` : null}>
            <div
              className='Notification-message Content u-inline'
              data-testid={testId ? `${testId}-content` : null}>
              {message && <span dangerouslySetInnerHTML={{ __html: sanitizeHTML(message) }} />}
              {children}
            </div>
          </div>
          {dismissable && (
            <button
              className='Button Button--icon'
              onClick={closeNotification}
              data-analytics={analytics}
              data-testid={testId ? `${testId}-close` : null}>
              <span className='u-hiddenVisually'>Dismiss notification</span>
              close
            </button>
          )}
        </div>
      </div>
    </section>
  )
}
